import type { FC } from "react";
import { useCallback, useState } from "react";
import classNames from "classnames";
import GAVerifiedIcon from "./GAVerifiedIcon";
import GAVerifiedTooltip from "./GAVerifiedTooltip";

import styled from "styled-components";
import { GAWizardModal } from "app/components/GA-verify/GAWizardModal";
type IGAVerifedContainerSize = "SMALL" | "MEDIUM" | "LARGE";
interface IGAVerifedContainer {
    size: IGAVerifedContainerSize;
    isActive: boolean;
    isPrivate: boolean;
    tooltipAvailable: boolean;
    tooltipIsActive: boolean;
    metric: string;
    top?: number;
}

const GAVerifiedContainer: FC<IGAVerifedContainer> = ({
    size,
    isActive,
    isPrivate,
    tooltipAvailable,
    tooltipIsActive,
    metric,
    top,
}) => {
    const GAVerifiedWrapper = styled.div<{
        top?: number;
    }>`
        ${({ top }) => (top ? `top: ${top}px` : "")};
    `;

    const _icon = (
        <GAVerifiedIcon
            isActive={isActive}
            size={size}
        />
    );

    let _privateRibbon = undefined;
    if (isPrivate && !(size == "SMALL")) {
        _privateRibbon = (
            <div className="GAVerified-private-ribbon">
                <i className="sw-icon-private" />
            </div>
        );
    }

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const onClose = () => setIsModalOpen(false);
    const onModalOpen = useCallback(() => setIsModalOpen(true), []);

    return (
        <>
            <GAVerifiedTooltip
                isEnabled={tooltipAvailable}
                isActive={isActive}
                isPrivate={isPrivate}
                openTooltip={tooltipIsActive}
                metric={metric}
                onGAWizardModalOpen={onModalOpen}
            >
                <GAVerifiedWrapper
                    top={top}
                    className={classNames("GAVerified-container", `GAVerified-container--${size}`)}
                >
                    {_icon}
                    {_privateRibbon}
                </GAVerifiedWrapper>
            </GAVerifiedTooltip>
            <GAWizardModal
                isOpen={isModalOpen}
                onClose={onClose}
            />
        </>
    );
};

export default GAVerifiedContainer;
